<template>
    <div class="padsm">
        <div id="chart_tree" style="min-height: 200px">

        </div>
    </div>
</template>
<style scoped>
#chart_cmnc {
    height: 200px;
}
</style>
<script>
import echarts from "echarts";
export default {
    props: ['data'],
    data() {
        return {
            myChart: '',
        }
    },
    computed: {
        list() {
            return this.data
        }
    },
    mounted() {
        let dom = document.getElementById("chart_tree")
        let num = this.data.children.length
        dom.style.height= num*10 +'px'
        this.myChart = echarts.init(dom);
        this.init()
    },
    methods: {
        init() {
            let option = {
                tooltip: {
                    trigger: 'item',
                    triggerOn: 'mousemove'
                },
                series: [
                    {
                        type: 'tree',

                        data: [
                           this.list
                        ],

                        top: '1%',
                        left: '7%',
                        bottom: '1%',
                        right: '20%',
                        symbol: 'emptyCircle',
                        symbolSize: 7,
                        label: {
                            position: 'left',
                            verticalAlign: 'middle',
                            align: 'right',
                            fontSize: 9
                        },
                        leaves: {
                            label: {
                                position: 'right',
                                verticalAlign: 'middle',
                                align: 'left'
                            }
                        },
                        expandAndCollapse: true,
                        animationDuration: 550,
                        animationDurationUpdate: 750
                    }
                ]
            }
            console.log('myChart', this.myChart)
            console.log('myChart-setOption', this.myChart.setOption)
            this.myChart.setOption(option);
        }
    }
}
</script>